var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WsTextChip001',{attrs:{"has-bg":"","leading-icon":"icon-warning-filled","text-label":"Major","icon-xl":"","font-size-md":"","big":"","red":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }